<template>
  <modal name="modal-move-linkcard" :adaptive="true" :scrollable="true" :height="'auto'" @before-open="beforeOpen">
    <div v-if="linkcard" class="modal-move-linkcard">
      <div class="modal-header">
        <h3>{{ $t('move_linkcard.title') }}</h3>
        <button class="close-button" @click="closeModal">&times;</button>
      </div>
      <div class="modal-body">
        <p>{{ $t('move_linkcard.description') }} <strong>{{ linkcard.info.nombre_landing || linkcard.info.nombre }}</strong></p>
        <div class="form-group">
          <label>{{ $t('move_linkcard.product') }}</label>
          <div class="move-linkcard-field" @click="focusSelect($event)">
            <select v-model="selectedProduct" class="form-control">
              <option value="bc">{{ $t('move_linkcard.products.bc') }}</option>
              <option value="pas">{{ $t('move_linkcard.products.pas') }}</option>
              <option value="lib">{{ $t('move_linkcard.products.lib') }}</option>
            </select>
          </div>
        </div>
        <div class="form-group">
          <label>{{ $t('move_linkcard.sector') }}</label>
          <div class="move-linkcard-field" @click="focusSelect($event)">
            <select v-model="selectedSector" class="form-control">
              <option v-for="sector in availableSectors" :key="sector.id" :value="sector.id">{{ sector.name }}</option>
            </select>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button class="btn btn-secondary" @click="closeModal">{{ $t('move_linkcard.cancel') }}</button>
        <button class="btn btn-primary" @click="moveLinkcard" :disabled="isMoveButtonDisabled">{{ $t('move_linkcard.move') }}</button>
      </div>
    </div>
  </modal>
</template>

<script>
import { db } from "@/services/firebaseConfig.js";

export default {
  data() {
    return {
      linkcard: null,
      selectedProduct: 'bc',
      selectedSector: null,
      sectors: []
    };
  },
  computed: {
    availableSectors() {
      if (!this.sectors) return [];
      let sectors = this.sectors.filter(sector => sector.type === this.selectedProduct);
      const defaultSector = this.sectors.find(sector => sector.id === 0 && !sector.type);
      if (this.selectedProduct === 'bc' && defaultSector) {
        sectors.unshift(defaultSector);
      }
      return sectors;
    },
    isMoveButtonDisabled() {
      return !this.selectedProduct || this.selectedSector === null || this.selectedSector === undefined;
    },
  },
  watch: {
    selectedProduct(newVal, oldVal) {
      if (oldVal && newVal !== oldVal) {
        this.selectedSector = null;
      }
    },
  },
  methods: {
    beforeOpen(event) {
      this.linkcard = event.params.linkcard;
      const user = this.$store.state.userProfile;
      this.sectors = user.sectors;
      if (this.linkcard) {
        this.selectedProduct = this.linkcard.type || 'bc';
        const sectorId = this.linkcard.sector_id;
        if (sectorId !== undefined && sectorId !== null && sectorId !== '') {
          this.selectedSector = Number(sectorId);
        } else {
          this.selectedSector = null;
        }
      }
    },
    focusSelect(event) {
      const select = event.currentTarget.querySelector('select');
      if (select) select.focus();
    },
    closeModal() {
      this.$modal.hide('modal-move-linkcard');
    },
    async moveLinkcard() {
      if (this.selectedSector === null || this.selectedSector === undefined) {
        this.$util.notif_error('Debe seleccionar una carpeta');
        return;
      }

      const profile = this.$store.state.userProfile;
      const linkcardIndex = profile.linckards
        ? profile.linckards.findIndex(l => l.id == this.linkcard.id)
        : -1;

      const updatePayload = {
        sector_id: String(this.selectedSector),
      };
      if (this.selectedProduct !== this.linkcard.type) {
        updatePayload.type = this.selectedProduct;
      }

      // Datos para el aviso de exito (nombre/id/destino) antes de cerrar el modal.
      const nombreLinkcard = this.linkcard.info.nombre_landing || this.linkcard.info.nombre;
      const destinoSector = this.sectors.find(s => s.id === this.selectedSector);
      const destinoNombre = destinoSector ? destinoSector.name : String(this.selectedSector);

      try {
        // Fuente de verdad: el doc individual en la coleccion 'linkcards'.
        // Al recargar el perfil (store/index.js) estos docs pisan el array
        // legacy del user-doc, asi que con este update alcanza para persistir.
        if (this.linkcard.uid) {
          await db.collection('linkcards').doc(this.linkcard.uid).update(updatePayload);
        }

        // Reflejo el cambio en memoria para la UI (el router.go(0) recarga igual).
        if (linkcardIndex !== -1) {
          profile.linckards[linkcardIndex].sector_id = updatePayload.sector_id;
          if (updatePayload.type) {
            profile.linckards[linkcardIndex].type = updatePayload.type;
          }
        }

        // NO reescribir el array completo de linckards en users/{uid}: ese campo
        // es un cache legacy y al crecer supera el limite de 1MB de Firestore
        // (era la causa del error "exceeds the maximum allowed size"). El guardado
        // canonico (guardarLinckardGeneral) ya dejo de escribirlo por lo mismo.

        // Aviso descriptivo. No hace falta recargar la pagina (antes: router.go(0)):
        // la lista (linkcardsFiltered) es un computed sobre el store y se actualiza
        // sola al cambiar el sector_id en memoria.
        this.$util.notif_success(
          this.$t('move_linkcard.moved_success', {
            nombre: nombreLinkcard,
            id: this.linkcard.id,
            destino: destinoNombre,
          })
        );
        this.closeModal();
      } catch (error) {
        console.error('Error al mover linkcard:', error);
        this.closeModal();
        this.$util.notif_error(this.$t('notis.error'));
      }
    },
  },
};
</script>

<style scoped>
.modal-move-linkcard {
  padding: 20px;
}
.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #eee;
  padding-bottom: 10px;
  margin-bottom: 20px;
}
.close-button {
  background: none;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
}
.modal-body {
  margin-bottom: 20px;
}
.modal-footer {
  border-top: 1px solid #eee;
  padding-top: 10px;
  display: flex;
  justify-content: flex-end;
  gap: 8px;
}
.form-group {
  margin-bottom: 15px;
}
.form-group label {
  display: block;
  margin-bottom: 6px;
  font-weight: 500;
}
.move-linkcard-field {
  border: 1px solid #d9d9d9;
  border-radius: 8px;
  min-height: 44px;
  cursor: pointer;
  overflow: hidden;
  background: #fff;
  transition: border-color 0.15s ease;
}
.move-linkcard-field:hover,
.move-linkcard-field:focus-within {
  border-color: #438FDE;
}
.move-linkcard-field select.form-control {
  width: 100%;
  height: 44px;
  border: none;
  border-radius: 0;
  padding: 8px 36px 8px 12px;
  cursor: pointer;
  background-color: transparent;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  background-image: url('~assets/images/dropdown_arrow_color.svg');
  background-repeat: no-repeat;
  background-position: right 12px center;
  background-size: 16px;
}
.move-linkcard-field select.form-control:focus {
  outline: none;
  box-shadow: none;
}
</style>
